<template>
<div>
	<div>
		<el-row>
			<el-col>
				<template>
					<el-date-picker class="mr-5 mb-10"
						style="top: 2px !important; width:220px;"
						v-model="selectedStartDateSession"
						:picker-options="pickerOptions"
						range-separator="to"
						size="mini"
						type="daterange"
						placeholder="Pick a day">
					</el-date-picker>
					<el-select v-model="selectedFilterSession" placeholder="Filter By" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5">
						<el-option
						v-for="itm in filterBySession"
						:key="itm.value"
						:label="itm.label"
						:value="itm.value">
						</el-option>
					</el-select>
					<el-input
						style="width:250px;"
						class="mb-10"
						size="mini"
						prefix-icon="el-icon-search"
						placeholder="Input number"
						clearable
						v-model="searchFbSession">
					</el-input>
					<el-button-group class="mr-10 ml-5">
						<el-button type="primary" size="mini" :loading="loadingSession" class="animated fadeInRight" @click="changeFilterSession">
							<i class="el-icon-search"/>
						</el-button>
					</el-button-group>
				</template>
			</el-col>
		</el-row>
		<el-row class="mb-10" style="font-size:14px;">
			<el-col :span="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingTemplate">
				<el-card style="background-color:#5EA369; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px; word-wrap: break-word;" class="mb-10">
					<span style="font-size:14px;">Active | Passive WABA</span><br>
					<span style="font-size:16px;">
						{{dataTotal && dataTotal.waba_active}} | {{dataTotal && dataTotal.waba_passive}}
					</span>

				</el-card>
			</el-col>
			<el-col :span="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingTemplate">
				<el-card style="background-color:#8CBC26; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px; word-wrap: break-word;" class="mb-10">
					<span style="font-size:14px;">Active | Passive Phone Number </span><br>
					<span style="font-size:16px;">
						{{dataTotal && dataTotal.phone_number_active}} | {{dataTotal && dataTotal.phone_number_passive}}
					</span>

				</el-card>
			</el-col>
			<el-col :span="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingTemplate">
				<el-card style="background-color:#5EA369; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px; word-wrap: break-word;" class="mb-10">
					<span style="font-size:14px;">Total BI </span><br>
					<span style="font-size:16px;">
						{{dataTotal && dataTotal.conversation_bi}}
					</span>

				</el-card>
			</el-col>
			<el-col :span="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingTemplate">
				<el-card style="background-color:#8CBC26; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px; word-wrap: break-word;" class="mb-10">
					<span style="font-size:14px;">Total UI </span><br>
					<span style="font-size:16px;">
						{{dataTotal && dataTotal.conversation_ui}}
					</span>

				</el-card>
			</el-col>
			<el-col :span="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingTemplate">
				<el-card style="background-color:#8CBC26; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px; word-wrap: break-word;" class="mb-10">
					<span style="font-size:14px;">Meta Revenue </span><br>
					<span style="font-size:16px;">
						{{ formatPrice(dataTotal && dataTotal.revenue_total || 0) }}
					</span>

				</el-card>
			</el-col>
		</el-row>
		<el-row v-if="warning" class="mt-10">
			<el-col>
				<el-card style="background-color:#FFEFB8; font-size:12px; color:black; font-weight:bold; word-wrap: break-word;" shadow="never">
				<ul>
					<li v-for="(item,i) in reqFbSessionWarn" :key="i"><span style="color:black;">{{`[ ${domainWarn.join(",")} ]`}} Contry Code hasn't set</span></li>
				</ul>
					<!-- <el-row ><el-col style="word-wrap: break-word"></el-col></el-row> -->
				</el-card>
			</el-col>
		</el-row>
	</div>

	<template>
		&nbsp;
		<el-pagination
			background
			prev-text="Prev"
			next-text="Next"
			layout="prev, pager, next"
			:page-size="10"
			@current-change="paginateFbSession"
			:current-page="currentPageSession"
			:total="parseInt(totalFbSession)"/>
		<br/>
		<el-table :data="reqFbSession" style="width: 100%;" v-loading="loadingTemplate" element-loading-text="Loading..." element-loading-spinner="el-icon-loading">
			<!-- <el-table-column prop="dateCreate" label="Created At" width="200">
				<template slot-scope="props">
					<p style="font-weight:bold;">{{ formatDate(props.row.dateCreate, "DD/MM/YY HH:mm:ss") }}</p>
				</template>
			</el-table-column> -->
			<el-table-column prop="identityNumber" label="WABA ID" width="250">
			</el-table-column>
			<el-table-column v-if="selectedFilterSession=='phone_number'" prop="phone_number" label="Phone Number" width="200"></el-table-column>
			<!-- <el-table-column prop="countryName" label="Country Name" width="250"></el-table-column>
			<el-table-column prop="maskingName" label="Domain" width="250" />
			<el-table-column prop="priceModel" label="Price Model" width="200"></el-table-column> -->
			<el-table-column prop="total_all_bi" label="Total BI" width="180">
			</el-table-column>
			<el-table-column prop="total_all_rev_bi" label="Revenue BI" width="180">
				<template slot-scope="props">
					<p style="font-weight:bold;">{{ formatPrice(props.row.total_all_rev_bi)}}</p>
				</template>
			</el-table-column>
			<el-table-column prop="total_all_ui" label="Total UI" width="180">
			</el-table-column>
			<el-table-column prop="total_all_rev_ui" label="Revenue UI" width="180">
				<template slot-scope="props">
					<p style="font-weight:bold;">{{ formatPrice(props.row.total_all_rev_ui)}}</p>
				</template>
			</el-table-column>
			<el-table-column prop="total_all_send" label="Send" width="180" />
			<el-table-column prop="total_all_delivered" label="Delivered" width="180" />
			<el-table-column prop="pic_business" label="PIC Business" width="180">
				<template slot-scope="props">
					<p style="font-weight:bold;" v-if="props.row.pic_business!=''">{{ props.row.pic_business }}</p>
					<span v-else></span>
				</template>
			</el-table-column>
			<el-table-column
				fixed="right"
				label="Action"
				width="100">
				<template slot-scope="scope">
					<el-button size="small" @click="detailFbSession(scope.row)">Detail</el-button>
					<!-- <el-button size="small" type="danger" @click="deleteFbIdentity(scope.row)">Delete</el-button> -->
				</template>
			</el-table-column>
		</el-table>
		&nbsp;
		<el-pagination
			background
			prev-text="Prev"
			next-text="Next"
			layout="prev, pager, next"
			:page-size="10"
			@current-change="paginateFbSession"
			:current-page="currentPageSession"
			:total="parseInt(totalFbSession)"/>
		<br/>
	</template>
	<el-dialog :close-on-click-modal="false" :title="`WABA ID : ${identityIdDetail}`" :visible.sync="modalDetailSession" style="width: 100%;">
		<template>
			<!-- <el-input
				class="search-customer mb-10 fl-l" style="width:100%;"
				prefix-icon="el-icon-search"
				placeholder="Search Customer Name"
				clearable
				@keypress.native="doSearchCustomer"
				@clear="doSearchCustomer"
				@keyup.native="doSearchCustomer"
				v-model="searchCustomer" debounce="500">
			</el-input> -->

			<div style="position:absolute; top: 50px; color: #303133; font-size: 18px;">
				<span><b>({{maskingNameDetail}})</b></span>
			</div>

			<el-select style="width: 40%; margin-top: 10px;" v-model="phoneNumberSessionSelected" @change="handleChangeSelectedSession" filterable placeholder="Select Country">
				<el-option
				v-for="(item,i) in phoneNumberSession" :key="i"
				:label="`+${item.label}`"
				:value="item.value">
				</el-option>
			</el-select>
			<div style="margin: 30px 0;"></div>
			<!-- <el-pagination
				background
				prev-text="Prev"
				next-text="Next"
				layout="prev, pager, next"
				:page-size="10"
				@current-change="paginateConsumen"
				:current-page="currentConsumenPage"
				:total="parseInt(total)">
			</el-pagination> -->
			<el-table
				:data="dataDetailSession"
				v-loading="loadingDetailSession"
				style="width: 100%">
					<!-- <el-table-column prop="identityNumber" label="WABA ID" width="250">
					</el-table-column> -->
					<el-table-column prop="phoneNumber" label="Phone Number" width="200"></el-table-column>
					<el-table-column prop="countryName" label="Country Name" width="250"></el-table-column>
					<el-table-column prop="domain" label="Domain" width="250" />
					<el-table-column prop="priceModel" label="Price Model" width="200">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{ props.row.priceModel || '-'}}</p>
						</template>
					</el-table-column>
					<el-table-column prop="total_bi" label="Total BI" width="150">
					</el-table-column>
					<el-table-column prop="revenue_bi" label="Revenue BI" width="150">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{ formatPrice(props.row.revenue_bi)}}</p>
						</template>
					</el-table-column>
					<el-table-column prop="total_ui" label="Total UI" width="150">
					</el-table-column>
					<el-table-column prop="revenue_ui" label="Revenue UI" width="150">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{ formatPrice(props.row.revenue_ui)}}</p>
						</template>
					</el-table-column>
					<el-table-column prop="send" label="Send" width="150" />
					<el-table-column prop="delivered" label="Delivered" width="150" />
			</el-table>
		</template>
	</el-dialog>
</div>
</template>

<script>
import api from '@/networkClient'
import config from '@/config'
const _ = require('lodash')
const moment = require('moment')
import CountryFlag from 'vue-country-flag'
const countryCodes = require('country-codes-list')

export default {
	name: 'Facebook_Price',
    props: {
		dataWarning: {
			type: Object	
		},
        dataSession: {
            type: Array
        },
		dataSummary: {
            type: Object
        },
        loadingData: {
            type: Boolean
        },
        date: {
            type: Array
        },
        total: {
            type : Number
        }
    },
	data () {
		return {
			dataTotal: {
				waba_active: 0,
				waba_passive : 0,
				phone_number_active: 0,
				phone_number_passive: 0,
				conversation_bi: 0,
				conversation_ui: 0,
				revenue_total: 0
			},
			warning: false,
			pickerOptions: {
				disabledDate: this.disabledDate
			},
			maskingNameDetail: "",
			identityIdDetail:"",
			loadingDetailSession: false,
			dataDetailSession:[],
			modalDetailSession: false,
			phoneNumberSessionSelected: "",
			idDetailSession: "",
			paginate: true,
			bodyStyle: {
				padding: "20px"
			},
			loadingSession: false,
			searchFbSession:"",
			filterBySession:[{value:"waba_id", label:"WABA ID"},{value:"phone_number", label:"Phone Number"},{value:"pic_business", label:"PIC Business"}],
			selectedFilterSession:"waba_id",
			selectedStartDateSession: [
                moment().subtract(1,"day").format("YYYY-MM-DD"),
                moment().subtract(1,"day").format("YYYY-MM-DD")
            ],
            price_bi: 0,
            price_ui: 0,
            country_code: '',
            country_name: "",
            domain_name: '',
			types: [{label: "WABA ID", value: "waba_id"},{label: "FBBM ID", value: "fbbm_id"}],
			phoneNumberSession: [],
            countries: [],
			mapingCountries: [],
			reqFbPriceIdentity:[],
			price_model_identity:[{model:{modelName: "",countryName: "", domainName:""}}],
            model_name:"",
			type_identity:"waba_id",
			identityNumber: "",
			maskingName: "",
            price_model: "1",
			price_model_edit: "1",
			editFbPrice: {},
			editIdentity: {},
			reqFbPrice: [],
			reqFbIdentity: [],
			reqFbSession: [],
			reqFbSessionWarn: [],
			domainWarn: [],
			loadingTemplate: true,
			loadingIdentity: false,
			currentPage: 1,
			currentPageRequest: 1,
			currentPageIdentity: 1,
			currentPageSession: 1,
			totalFbPrice: 0,
			totalFbIdentity: 0,
			totalFbSession: 0,
			dialogFormVisible:false,
			dialogFormVisibleIdentity:false,
			dialogFormVisibleEdit:false,
			dialogFormVisibleEditIdentity:false,
			loadingBtn:false,
			formLabelWidth: '200px',
			timeout: null,
			searchFbPrice:'',
			searchFbIdentity:'',
			activeTab: "fbidentity",
			activeTabSession: "index",
			loadingApproved: false
		}
	},
    components: {
        CountryFlag
    },
	methods: {
		disabledDate(date) {
			// console.log('date disable', date);
			var today = moment(), diff = today.diff(moment(date), 'd')
						if(diff < 1){
							return true
						} else {
							if(diff == 0){
								if(today.isSame(moment(date), 'd') == false){
									return true
								} else {
									return false
								}
							}
							return false
						}
				// return new Date() < date
		},
		changeFilterSession(){
			console.log("filter session");
			if (this.selectedStartDateSession) {
				let today = moment(this.selectedStartDateSession[1]), diff = today.diff(moment(this.selectedStartDateSession[0]), 'd')
				if (diff > 30) {
					this.$swal(this.$t('info'), "Can't set filter date more than 30 days.", "info")
					return
				}
			}
			this.getFbSession(1,this.selectedFilterSession)
			this.getFbSessionSummary(this.selectedFilterSession)
		},
		find_duplicate_in_array(arra1, param) {
			var object = {};
			var result = [];

			arra1.forEach(function (item) {
			if(!object[item[param].countryName])
				object[item[param].countryName] = 0;
				object[item[param].countryName] += 1;
			})

			for (var prop in object) {
			if(object[prop] >= 2) {
				result.push(prop);
			}
			}

			return result;

		},
		addModel(){
			this.price_model_identity.push({model:{modelName: "",countryName: "", domainName:""}})
		},
		addModelEdit(){
			this.editIdentity.price_model.push({facebook_price:{modelName: "",countryName: "", domainName:""}})
		},
		deleteModel(i){
			this.price_model_identity.splice(i,1)
		},
		deleteModelEdit(i){
			this.editIdentity.price_model.splice(i,1)
		},
		formatType(val){
			let result = ""
			result = val.replace("_", " ").toUpperCase();
			return result ;
		},
		formatPrice(val){
			return new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", minimumFractionDigits: 0 }).format(val);
		},
        numberOnly(e) {
            var key = window.event ? e.keyCode : e.which;

            let isNumber = _.indexOf([8, 9, 27, 13, 190, 43], e.keyCode)
            if ( isNumber !== -1 ||
                // Allow: Ctrl+C, Command+C
                (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+A, Command+A
                (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+R, Command+R
                (e.keyCode === 82 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: home, end, left, right, down, up
                (e.keyCode > 42 && e.keyCode <= 49 && _.indexOf([44,45,47], e.keyCode) == -1)) {
                // let it happen, don't do anything
                return
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode > 96 || e.keyCode < 200)) {
                e.preventDefault();
            }
        },
        paste(event, field, field2 = undefined) {
            event.preventDefault()
            var totalCharacterCount = window.event.clipboardData.getData('Text');// || window.clipboardData.getData('Text');
            var strValidChars = "+0123456789";
            var strChar;
            var FilteredChars = "";
            for (var i = 0; i < totalCharacterCount.length; i++) {
                strChar = totalCharacterCount.charAt(i);
                if (strValidChars.indexOf(strChar) != -1) {
                    FilteredChars = FilteredChars + strChar;
                }
            }

			console.log(field);
			console.log(FilteredChars);

			if (field2) {
				this[field][field2] = FilteredChars
			}
			else{
				this[field] = FilteredChars
			}
        },
		async detailFbSession(val){
			console.log(val);
			console.log(this.phoneNumberSession);
			this.idDetailSession = val.id
			this.identityIdDetail = val.identityNumber
			this.maskingNameDetail = val.maskingName || '-'
			this.phoneNumberSession = val.sessions.map(el => {
					let obj = {
						label: el.phoneNumber,
						value: el.phoneNumber
					}
					return obj
				})
			this.phoneNumberSessionSelected = this.phoneNumberSession[0].value || null
			this.modalDetailSession = true
			await this.getFbSessionDetail()
		},
		async handleChangeSelectedSession(val){
			this.phoneNumberSessionSelected = val
			await this.getFbSessionDetail()
		},
		async handleChangeSelectedModel(val, key){
			console.log(val);
			let find = this.reqFbPriceIdentity[key].find(el => el.id == val)
			this.price_model_identity[key].model.domainName = find ? find.domainName : null
		},
		async handleChangeSelectedModelEdit(val, key){
			console.log(val);
			let find = this.reqFbPriceIdentity[key].find(el => el.id == val)
			this.editIdentity.price_model[key].facebook_price.domainName = find ? find.domainName : null
		},
		async handleChangeSelectedCountryModel(val, key){
            console.log('val', val, key);
			this.searchFbPrice = val
			this.price_model_identity[key].model.modelName = ""
			this.price_model_identity[key].model.domainName = ""
			this.price_model_identity[key].model.id = ""
			this.loadingIdentity = true
            await this.getFbPrice()
			this.reqFbPriceIdentity[key] = this.reqFbPrice
            this.loadingIdentity = false
        },
		async handleChangeSelectedCountryModelEdit(val, key){
            console.log('val', val, key);
			this.searchFbPrice = val
			this.editIdentity.price_model[key].facebook_price.modelName = ""
			this.editIdentity.price_model[key].facebook_price.domainName = ""
			this.editIdentity.price_model[key].facebook_price.id = ""
			this.loadingIdentity = true
            await this.getFbPrice()
			this.reqFbPriceIdentity[key] = this.reqFbPrice
            this.loadingIdentity = false
        },
		handleChangeSelectedIdentity(val){
			console.log(val);
			if (val == "waba_id" && this.editIdentity.price_model.length == 0) {
				this.editIdentity.price_model.push({facebook_price:{modelName: "",countryName: "", domainName:""}})
			}
		},
        handleChangeSelectedCountry(val){
            console.log('val', val);
            let find = this.countries.find(el => el.countryNameEn == val)
            if (find) {
                this.country_code = "+" + find.countryCallingCode
                this.domain_name = find.countryCode    
            }
            
        },
		handleChangeSelectedCountryEdit(val){
            console.log('val', val);
            let find = this.countries.find(el => el.countryNameEn == val)
            if (find) {
                this.editFbPrice.country_code = "+" + find.countryCallingCode
                this.editFbPrice.domain_name = find.countryCode    
            }
            
        },
		getBodyText(components){
			let c = components.find(v => v.type.toLowerCase() == "body")
			if(c){
				return c.text
			} else {
				return ""
			}
		},
		tabClickSession(tab){
			if(tab.name == "index"){
				this.getFbIdentity()
			} else if(tab.name == "upload"){
				
			}
		},
		readMore(text){
			if(text){
				if(text.length > 100) return text.substring(0, 100) + "..."
				else return text
			} else{
				return text
			}
		},
		deleteRow(index, rows) {
            rows.splice(index, 1);
        },
		capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
				return string.charAt(0).toUpperCase() + string.substring(1);
			}
		},
		formatDate(val, format){
			if(val) return moment(val).format(format)
			else return "-"
		},
		async paginateFbSession(page) {
			this.currentPageSession = page
			await this.getFbSession(page, this.selectedFilterSession)
		},
		async getFbIdentity(page = 1, filter = null){
			this.loadingTemplate = true
			await api({
				url: config.baseApi+'bussiness/get-fb-identity',
				method: 'GET',
				params: {
					page: page,
					all: filter ? true: null,
					filter: filter,
					search: this.searchFbIdentity
				}
			}).then(({ data }) => {
				console.log(data.data.data);
				this.reqFbIdentity = data.data.data
				if(filter){
					this.totalFbIdentity = this.reqFbIdentity.length
				}
				else{
					this.totalFbIdentity = data.data.total
					
				}
				this.loadingTemplate = false
			}).catch(error => {
				this.loadingTemplate = false
			})
		},
		async getFbSession(page = 1, filter = null){
			if (!this.selectedStartDateSession || !this.selectedStartDateSession[0] || !this.selectedStartDateSession[1]) {
				return
			}
			this.loadingTemplate = true
			await api({
				url: config.baseApi+'bussiness/get-fb-sessions',
				method: 'GET',
				params: {
					page: page,
					filter: filter,
					search: this.searchFbSession,
					startDate: this.selectedStartDateSession[0] || null,
					endDate: this.selectedStartDateSession[1] || null
				}
			}).then(({ data }) => {
				console.log(data.data.data);
				this.reqFbSession = data.data.data
				console.log("req fb session",this.reqFbSession)
				this.totalFbSession = data.data.total
				this.loadingTemplate = false
			}).catch(error => {
				this.loadingTemplate = false
			})
		},
		async getFbSessionSummary(filter = null){
			if (!this.selectedStartDateSession || !this.selectedStartDateSession[0] || !this.selectedStartDateSession[1]) {
				return
			}

			this.loadingTemplate = true
			await api({
				url: config.baseApi+'bussiness/get-fb-sessions-summary',
				method: 'GET',
				params: {
					search: this.searchFbSession,
					filter: filter,
					startDate: this.selectedStartDateSession[0] || null,
					endDate: this.selectedStartDateSession[1] || null
				}
			}).then(({ data }) => {
				console.log(data.data.data);
				this.dataTotal = data.data.data
				this.loadingTemplate = false
			}).catch(error => {
				this.loadingTemplate = false
			})
		},
		async getFbSessionDetail(page = 1){
			this.loadingDetailSession = true
			await api({
				url: config.baseApi+'bussiness/get-fb-sessions/' + this.idDetailSession,
				method: 'GET',
				params: {
					phone_number: this.phoneNumberSessionSelected,
					startDate: this.selectedStartDateSession[0] || null,
					endDate: this.selectedStartDateSession[1] || null
				}
			}).then(({ data }) => {
				console.log(data.data.data);
				this.dataDetailSession = data.data.data
				this.loadingDetailSession = false
			}).catch(error => {
				this.loadingDetailSession = false
			})
		},
		// clear(){
		// 	this.editFbPrice = {}
		// 	this.editIdentity = {}
		// 	this.price_model_identity = [{model:{modelName: "",countryName: "", domainName:""}}]
		// 	this.price_bi = 0
        //     this.price_ui = 0
        //     this.country_code = ''
        //     this.country_name = ""
        //     this.domain_name = ''
        //     this.model_name =""
        //     this.price_model = "1",
		// 	this.type_identity = "waba_id"
		// 	this.maskingName = ""
		// 	this.identityNumber = ""
		// }
	},
	watch: {
		dataWarning: function() {
			this.reqFbSessionWarn = []
			this.domainWarn = []
			for (const key in this.dataWarning) {
				if (Object.hasOwnProperty.call(this.dataWarning, key)) {
					this.reqFbSessionWarn.push({[key] : this.dataWarning[key]});
				}
			}
            // this.reqFbSessionWarn = this.dataWarning
			this.warning = this.reqFbSessionWarn.length > 0 ? true: false

			if (this.warning) {
				this.reqFbSessionWarn.forEach(el => {
					if (el.domain) {
						el.domain.forEach(v =>{
							this.domainWarn.push(v.domain)
						})
					}
				})
			}
			// this.domainWarn = this.reqFbSessionWarn[] ? this.reqFbSessionWarn.domain.map(el => el.domain) : []
			console.log("this.reqFbSessionWarn", this.reqFbSessionWarn);
        },
        dataSession: function() {
            this.reqFbSession = this.dataSession
			console.log("this.reqFbSession", this.reqFbSession);
        },
		dataSummary: function() {
            this.dataTotal = this.dataSummary
        },
		date: function() {
            this.selectedStartDateSession = this.date
        },
        loadingData: function() {
           this.loadingTemplate = this.loadingData          
        },
        total: function() {
            this.totalFbSession = this.total
        }
    },
	// async mounted(){
    //     // await this.paginateFbPrice()
    //     this.getFbIdentity()
	// 	this.getFbSession()
	// 	this.getFbPrice()
	// },
    created(){
        this.countries = countryCodes.all()
    }
}
</script>

<style lang="scss" scoped>
.float-image {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.fl-r {
	float:right;
}
.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}
</style>
